import React from "react";
import { ConnectingBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import ProgressBar from "../ProgreesBar/ProgressBar";
import graph from "./../../resources/images/connecting/graph.png";
import LoadButton from "../design_components/LoadButton/LoadButton";
import { useHistory } from "react-router";
import Button from "../design_components/Button/Button";
import { createEventObjectFunction } from "../../utils/helper";
import { onboardingFillEventAmplitude } from "../../amplitude/events";
import { onboardingFillEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";
import ReactPixel from "react-facebook-pixel";

const Connecting = ({ data, answers, pixelObject, landingId }) => {
  const history = useHistory();
  const setTitle = () => {
    if (data.dependOn && data.dependOn.length) {
      return data.title[answers[data.dependOn[0]]][answers[data.dependOn[1]]];
    } else {
      return data.question;
    }
  };

  const handleButtonClick = () => {
    if (data.pixelEvent) {
      ReactPixel.trackCustom(data.pixelEvent, pixelObject);
    }
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    history.push(data.nextRoute);
  };

  return (
    <ConnectingBlock>
      <Container.Content>
        <ProgressBar
          currentBlock={data.questionBlock}
          currentQuestion={data.questionNum}
          totalQuestion={data.totalQuestion}
        />
        <ConnectingBlock.Wrapper style={{ paddingTop: 40 }}>
          <ConnectingBlock.Top>
            {data.title && (
              <ConnectingBlock.Top.Title style={{ marginBottom: 47 }}>
                <Heading.Third>{setTitle()}</Heading.Third>
              </ConnectingBlock.Top.Title>
            )}
            {data.text && (
              <ConnectingBlock.Top.Text style={{ textAlign: "left" }}>
                <Text.Fourth style={{ fontWeight: 600 }}>
                  {data.text}
                </Text.Fourth>
              </ConnectingBlock.Top.Text>
            )}
            <ConnectingBlock.Top.Img style={{ marginBottom: 28 }}>
              <img src={data.img} alt="graph" />
            </ConnectingBlock.Top.Img>
            <ConnectingBlock.Top.Subtext>
              <Text.Fifth>{data.subtext}</Text.Fifth>
            </ConnectingBlock.Top.Subtext>
          </ConnectingBlock.Top>
          <ConnectingBlock.Bottom>
            {data.littleText && (
              <ConnectingBlock.Little>
                <Text.Fifth>{data.littleText}</Text.Fifth>
              </ConnectingBlock.Little>
            )}
            {data.loadingArray ? (
              <LoadButton
                loadingArray={data.loadingArray}
                loadingTextArray={data.loadingTextArray}
                action={handleButtonClick}
              />
            ) : (
              <Button
                text={"Continue"}
                isGradient={true}
                type={"default"}
                action={handleButtonClick}
              />
            )}
          </ConnectingBlock.Bottom>
        </ConnectingBlock.Wrapper>
      </Container.Content>
    </ConnectingBlock>
  );
};

export default Connecting;
